import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

interface ComplianceGaugeProps {
  verifiedCount: number;
  totalCount: number;
  title?: string;
}

export function ComplianceGauge({ verifiedCount, totalCount, title = "Document Compliance" }: ComplianceGaugeProps) {
  const percentage = totalCount > 0 ? (verifiedCount / totalCount) * 100 : 0;
  
  const getColor = () => {
    if (percentage >= 90) return 'text-green-600';
    if (percentage >= 70) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getStatus = () => {
    if (percentage >= 90) return 'Excellent';
    if (percentage >= 70) return 'Good';
    return 'Needs Attention';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-center">
            <div className={`text-5xl font-bold ${getColor()}`}>
              {percentage.toFixed(1)}%
            </div>
          </div>
          <Progress value={percentage} className="h-3" />
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>{verifiedCount} verified</span>
            <span>{totalCount} total</span>
          </div>
          <div className="text-center">
            <span className={`text-sm font-medium ${getColor()}`}>
              {getStatus()}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
